import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "text-body-1" };
const _hoisted_2 = { class: "d-flex flex-grow-1 justify-end body2-text brg-color-grey-600 text-right" };
const _hoisted_3 = {
    key: 0,
    class: "d-inline-block text-truncate"
};
const _hoisted_4 = { class: "d-flex flex-shrink-0" };
const _hoisted_5 = {
    key: 1,
    class: "ms-2"
};
const _hoisted_6 = { class: "d-flex flex-shrink-0" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_card_title = _resolveComponent("v-card-title");
    const _component_v_card_text = _resolveComponent("v-card-text");
    const _component_v_card = _resolveComponent("v-card");
    return (_openBlock(), _createBlock(_component_v_card, {
        flat: "",
        tile: "",
        class: "pb-4"
    }, {
        default: _withCtx(() => [
            _createCommentVNode(" 상태, 생성시간 "),
            _createVNode(_component_v_card_title, { class: "d-flex pb-0" }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t(_ctx.item.status)), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.item.createdAt), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
            }),
            _createCommentVNode(" ( 배차요청, 즉시배차인 경우 '대상: 라이더명' ) + ( 메모 ) "),
            (_ctx.allocatedWorkerNameOrUpdateMemo)
                ? (_openBlock(), _createBlock(_component_v_card_text, {
                    key: 0,
                    class: "body2-text brg-color-grey-600 pt-2 pb-0"
                }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.allocatedWorkerNameOrUpdateMemo), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }))
                : _createCommentVNode("v-if", true),
            _createCommentVNode(" 이름, 코드, 전화번호 "),
            _createVNode(_component_v_card_title, { class: "detail-info d-flex flex-nowrap body2-text brg-color-grey-600 pt-2 pb-0" }, {
                default: _withCtx(() => [
                    (_ctx.item.name)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.item.name), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.item.id), 1 /* TEXT */),
                    (_ctx.item.tel)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, " | "))
                        : _createCommentVNode("v-if", true),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.item.tel), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
            }),
            _createCommentVNode(" 소속 "),
            _createVNode(_component_v_card_title, { class: "body2-text brg-color-grey-600 pt-1 pb-0" }, {
                default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.item.agency), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
            })
        ]),
        _: 1 /* STABLE */
    }));
}
